import { commons } from "@/services/requests";
import { useRouter } from "next/router";
import { parseCookies, setCookie } from "nookies";
import { useMutation, useQueryClient } from "react-query";

export default function useAddBasket() {
  const { locale_path, uuid } = parseCookies();
  const { push } = useRouter();

  const queryClient = useQueryClient();

  const {
    mutate: addCard,
    isLoading: isLoadingAddCard,
    data: dataAddCard,
  } = useMutation((id: number) => commons.postAddCard(id, uuid), {
    onSuccess: ({ data }) => {
      if (data.uuid) {
        setCookie(null, "uuid", data.uuid, {
          maxAge: 30 * 24 * 60 * 60,
          path: `/`,
        });
      }

      window.location.href = `/${locale_path}/basket`;

    },
  });

  const { mutate: incrementBasket, isLoading: isLoadingIncrementBasket } =
    useMutation((id: number) => commons.postIncrementBasket(id), {
      onSuccess: () => {
        queryClient.invalidateQueries(["BASKET"]);
      },
    });

  const { mutate: decrementBasket, isLoading: isLoadingDecrementBasket } =
    useMutation((id: number) => commons.postDecrementBasket(id), {
      onSuccess: () => {
        queryClient.invalidateQueries(["BASKET"]);
      },
    });

  return {
    addCard,
    isLoadingAddCard,
    dataAddCard,
    incrementBasket,
    isLoadingIncrementBasket,
    decrementBasket,
    isLoadingDecrementBasket,
  };
}
